import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon, ShoppingBagIcon } from 'lucide-react';
import { purchases } from '../data/content';
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [purchase, setPurchase] = useState(purchases[0]);
  useEffect(() => {
    let hideTimer = 0;
    const show = () => {
      setPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      hideTimer = window.setTimeout(() => setVisible(false), 6000);
    };
    const first = window.setTimeout(show, 4000);
    const interval = window.setInterval(show, 18000);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-194" data-mp="1cyn07km3jn94">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 24
    }} transition={{
      duration: 0.24,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-3 left-3 right-3 z-50 flex justify-center sm:left-auto sm:right-4 sm:justify-end" role="status" aria-live="polite" data-id="element-195" data-mp="1cvhe8e8rl1hm">
          <div className="relative w-full max-w-[290px] overflow-hidden rounded-lg border-2 border-mustard bg-white p-2.5 pr-8 shadow-[0_0_22px_rgba(196,147,63,0.45)]" data-id="element-196" data-mp="1fv0wi4wcy93h">
            <span className="absolute left-0 top-0 h-1 w-full bg-terracotta" data-id="element-197" data-mp="n7wjbcn42ogm" />
            <div className="flex items-center gap-2.5" data-id="element-198" data-mp="i8tp6n8o62nf">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-terracotta/40 bg-terracotta/10 text-terracotta" data-id="element-199" data-mp="ia4pgd2wos9s">
                <ShoppingBagIcon className="h-4 w-4" aria-hidden="true" data-id="element-200" data-mp="s56fdb509ydf" />
              </span>
              <div className="leading-tight" data-id="element-201" data-mp="28jesyg7ssxcx">
                <p className="text-[13px] font-extrabold text-navy" data-id="element-202" data-mp="28maqi3fqhk0u">
                  {purchase.name}
                </p>
                <p className="text-[10px] font-semibold text-graphite/70" data-id="element-203" data-mp="2aotio8qhnng1">
                  {purchase.city}, {purchase.country}
                </p>
                <p className="mt-0.5 text-[11px] font-bold text-terracotta" data-id="element-204" data-mp="2fm37bm61zv2t">
                  just purchased SENIOR ACTIVITY READY™
                </p>
              </div>
            </div>
            <button type="button" onClick={() => setVisible(false)} aria-label="Close notification" className="absolute right-1.5 top-1.5 rounded p-0.5 text-graphite/50 transition-colors duration-150 ease-out hover:text-navy focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-navy" data-id="element-205" data-mp="2pkizlsgthadw">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-206" data-mp="26nrhvngxb3by" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}